import { type FC } from 'react';
import {
  ListBullets
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconListBulletsProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconListBullets: FC<UiIconListBulletsProps> = (props) => {
  return (
    <UiIcon
      IconComponent={ListBullets}
      {...props}
    />
  );
};
